import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HsCodeSuggestionsResult } from '../entities/HsCodeSuggestion';

@Injectable({
    providedIn: 'root'
})
export class HsCodeSuggestionsService {

    constructor(private httpClient: HttpClient) { }

    public getSuggestions(description: string, language: string): Observable<HsCodeSuggestionsResult> {
        const params = new HttpParams()
            .set('description', description)
            .set('countryCode', 'FO')
            .set('languages', language === 'en' ? 'en' : 'fo');

        return this.httpClient.get<HsCodeSuggestionsResult>(
            `${environment.apiUrl}/api/Customs/HsCodeSuggestions`, { params });
    }
}